module.exports = __webpack_public_path__ + "static/media/Active_Btid.e90ee19a.csv";